export default __webpack_public_path__ + "static/media/denis-serrano-decorate-review.7d140160.jpg";